import * as z from "zod";

const RecoverAutomationDomainSchema = z.object({
  exists: z.boolean(),
  discountId: z.string().nullable(),
  guidance: z.string(),
});

export const getRecoverOnboardingDomain = {
  name: "getRecoverOnboardingDomain" as const,
  input: z.object({}),
  output: z.object({
    automations: z.object({
      checkout_abandonment: RecoverAutomationDomainSchema,
      cart_abandonment: RecoverAutomationDomainSchema,
      browse_abandonment: RecoverAutomationDomainSchema,
      customer_winback: RecoverAutomationDomainSchema.extend({
        daysSinceLastOrder: z.number().nullable(),
      }),
    }),
    integrations: z.object({
      attentive: z.boolean(),
      klaviyo: z.boolean(),
      postscript: z.boolean(),
    }),
    tenDlcStarted: z.boolean(),
    /** An RCS agent registration row already exists for the team's account. */
    rcsStarted: z.boolean(),
    /** Prefill for the RCS opt-in disclosure, matching the admin registration card. */
    rcsOptInDisclosure: z.string(),
  }),
};
